import $ from "jquery";

const init = () => {
  handlerPosts();
  setupCopyButton();
  setupShareButtons();
};

const el = {
  main: ".SS-blogpost",
  copyContainer: "#SS-blog-copy",
};

const handlerPosts = () => {
  const postContainer = $(el.main);
  if (postContainer.length === 0) return;
  $(".elementor-post__thumbnail").each(function () {
    const $thumb = $(this);
    const $img = $thumb.find("img");

    if (!$img.parent().hasClass("img-wrapper")) {
      $img.wrap("<div class='img-wrapper'></div>");
    }
  });

  postContainer.find("article").each(function () {
    const $article = $(this);
    let hoverTimeout;

    $article.hover(
      function () {
        clearTimeout(hoverTimeout);

        const $link = $article.find(".elementor-post__thumbnail");
        let $button = $article.find(".SS-btn-blogpost");

        if ($button.length === 0) {
          $button = $(`
            <button class="SS-btn-blogpost" style="
              z-index: 10;
              position: absolute;
              width: 96%;
              top: 75%;
              left: 2%;
              padding: 8px !important;
            ">
              Klik om meer te lezen
            </button>
          `);
          $link.prepend($button);

          $button[0].offsetHeight;
        }

        $button.removeClass("slide-out").addClass("slide-in");
      },
      function () {
        const $button = $article.find(".SS-btn-blogpost");

        if ($button.length > 0) {
          $button.removeClass("slide-in").addClass("slide-out");

          hoverTimeout = setTimeout(() => {
            $button.remove();
          }, 300);
        }
      }
    );
  });
};
const setupCopyButton = () => {
  const $button = $("#SS-blog-copy");

  if ($button.length === 0) return;

  $button.on("click", (e) => {
    e.preventDefault();

    const currentUrl = window.location.href;

    // Create a temporary textarea to hold the text
    const $tempInput = $("<textarea>");
    $tempInput.val(currentUrl).css({
      position: "fixed", // prevent scrolling to bottom
      top: 0,
      left: 0,
      opacity: 0,
    });
    $("body").append($tempInput);

    $tempInput.focus();
    $tempInput.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        showCopiedNotification($button);
      } else {
        alert("Failed to copy the link.");
      }
    } catch (err) {
      alert("Failed to copy the link.");
    }

    $tempInput.remove();
  });
};

const showCopiedNotification = ($button) => {
  const $msg = $("<span class='copy-msg'>Link copied!</span>");
  $msg.css({
    position: "absolute",
    background: "#333",
    color: "#fff",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    top: $button.offset().top - 30,
    left: $button.offset().left,
    zIndex: 9999,
  });

  $("body").append($msg);

  setTimeout(() => {
    $msg.fadeOut(300, () => $msg.remove());
  }, 1500);
};
const setupShareButtons = () => {
  const currentUrl = encodeURIComponent(window.location.href);

  $("#SS-fb-share").on("click", function (e) {
    e.preventDefault();

    const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;

    window.open(fbShareUrl, "_blank", "width=600,height=400");
  });

  $("#SS-ig-share").on("click", function (e) {
    e.preventDefault();

    const igProfileUrl = "https://www.instagram.com/";
    // Open Instagram profile in new tab
    window.open(igProfileUrl, "_blank");
  });
};

try {
  init();
} catch (error) {
  console.log(`Error Handler Posts:`, error);
}
